<template>
  <div class="interest">
    <div class="interest-con">
      <div class="title">我的兴趣标签</div>
      <div class="next" @click="handleEdit">{{isEdit ? '完成' :'编辑'}}</div>
      <div class="interest-block">
        <div class="block-cons">
          <div class="cons-txt"
           v-for="(item_index, keys) in iepTags" :key="keys" :class="item_index.checked ? 'cur1' : ''">
            <img v-if="isEdit" src="../../assets/images/person/label_delete@2x.png" @click="handleDelItems(item_index, keys)" class="close-img" alt="">
            {{ item_index.interestTag || item_index.tagName }}</div>
        </div>
      </div>
    </div>
    <div class="interest-con">
      <div class="title">更多兴趣标签</div>
      <div class="interest-block" v-for="(item, keys_index) in interArr" :key="keys_index">
        <div class="block-title">{{ keys_index }}</div>
        <div class="block-cons">
          <div class="cons-txt" @click="handleClickItems(item_index, keys)" v-for="(item_index, keys) in item" :key="keys">
            + {{ item_index.interestTag || item_index.tagName }}
          </div>
        </div>
      </div>
    </div>
    <returnBack></returnBack>
  </div>
</template>
<script>
import { interestTagList, interestTagSave, iepUserInterest } from '@/api/person'
import returnBack from './components/returnBack.vue'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  components: {
    returnBack
  },
  data () {
    return {
      interArr: [],
      itemTxt: [],
      allArr: [],
      iepTags: [],
      isEdit: false,
      defaultTags: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    this.handleFun()
  },
  methods: {
    handleFun() {
      iepUserInterest({ iepUserId: this.userInfo.id }).then(res => {
        this.iepTags = res.data
        this.defaultTags = res.data
      })
      interestTagList().then(res => {
        let arrs = this.iepTags.map(res => res.id)
        this.allArr = res.data.filter((item) => {
          return (!arrs.includes(item.id))
        })
        this.handleFomt(this.allArr)
      })
    },
    // 打开编辑
    handleEdit() {
      if (this.iepTags.length <= 0 && this.defaultTags.length > 0) {
        this.$toast('请至少选择一个兴趣标签')
        return
      }
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        let params = this.iepTags.map(res => {
          return {
            iepUserId: this.userInfo.id,
            interestTag: res.interestTag
          }
        })
        interestTagSave(params).then(res => {
          this.$toast('编辑成功')
          this.handleFun()
        })
      }
    },
    handleFomt(arr) {
      let obj = {}
      if (arr.length <= 0) {
        this.interArr = []
        return
      }
      if (arr.length === 1) {
        obj[arr[0].tagType] = arr
        this.interArr = obj
        return
      }
      this.interArr = arr.reduce((pre, cur, index, arr) => {
        if (pre && pre.tagType) {
          obj[pre.tagType] = [pre]
        }
        if (Object.keys(obj).includes(cur.tagType)) {
          obj[cur.tagType].push(cur)
        } else {
          obj[cur.tagType] = [cur]
        }
        return obj
      })
    },
    handleClickItems (item, keys) {
      if (!this.isEdit) return
      item.interestTag = item.tagName
      item.checked = true
      this.iepTags = this.iepTags.concat(item)
      let arrsId = this.iepTags.map(res => res.id)
      this.allArr = this.allArr.filter((res) => {
        return (!arrsId.includes(res.id))
      })
      this.handleFomt(this.allArr)
    },
    handleDelItems(item) {
      item.tagName = item.interestTag ? item.interestTag : item.tagName
      this.allArr = this.allArr.concat(item)
      this.iepTags = this.iepTags.filter((res) => {
        return res.id !== item.id
      })
      this.handleFomt(this.allArr)
    },
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.interest {
  width: 100vw;
  min-height: 100vh;
  background-color: #fff;
  padding: 28px 18px;
  box-sizing: border-box;
  position: relative;

  .title {
    color: rgba(0, 0, 0, .9);
    font-weight: 600;
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 14px;
  }

  .next {
    position: absolute;
    right: 14px;
    top: 23px;
    line-height: 22px;
    font-size: 15px;
    color: #EB1700;
    font-weight: 500;
    border: 1px solid #EB1700;
    border-radius: 100px;
    width: 62px;
    height: 26px;
    text-align: center;
    line-height: 28px;
    box-sizing: border-box;
  }

  .interest-block {
    margin-bottom: 16px;

    .block-title {
      color: rgba(0, 0, 0, .9);
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 9px;
      padding-left: 6px;
      position: relative;
      &::before {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background-color: #EB1700;
        border-radius: 12px;
        content: '';
        width: 3px;
        height: 13px;
      }
    }

    .block-cons {
      display: flex;
      flex-wrap: wrap;

      .cons-txt {
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #F9F8F7;
        font-size: 13px;
        color: #564C47;
        text-align: center;
        line-height: 35px;
        height: 35px;
        margin-bottom: 7px;
        position: relative;
        padding:  0 16px;
        box-sizing: border-box;
        margin-right: 7px;
        .close-img {
          position: absolute;
          width: 16px;
          height: 16px;
          right: -5px;
          top: -7px;
        }
        &.cur {
          background-color: #EB1700;
          color: #FFFFFF;
        }
        &.cur1 {
          border: 1px solid rgb(0, 0, 0);
          background: rgb(249, 248, 247);
        }
      }
    }
  }

}</style>



// WEBPACK FOOTER //
// src/views/person/editInterest.vue